import { TextArea } from "@hid-galaxy-ui/galaxy-react";
import "./CustomTextArea.scss";

interface CustomTextAreaProps {
  fieldKey: string;
  fieldLabel: string;
  fieldHelperText?: string;
  fieldValue: string;
  isRequired?: boolean;
  handleChange: (key: string, value: string) => void;
}

const CustomTextArea: React.FC<CustomTextAreaProps> = ({
  fieldKey,
  fieldLabel,
  fieldHelperText = "",
  fieldValue,
  isRequired = false,
  handleChange,
}) => {
  return (
    <div className="custom-textarea-form-group">
      <TextArea
        label={fieldLabel}
        placeholder=""
        id={fieldKey}
        name={fieldKey}
        helperText={fieldHelperText}
        value={fieldValue}
        required={isRequired}
        maxLength={500}
        theme="dark"
        isRequired={isRequired}
        onChange={(e:any) => handleChange(fieldKey, e.currentTarget.value)}
      />
    </div>
  );
};

export default CustomTextArea;
